import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]

class FenamixAforoDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Visita Tamaulipas' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                
                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--4"  data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">GESTIÓN AFORO FENAMIX V</h2>
                                    <p>Gestión de aforo del evento Congreso Fenamix V. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Portfolio Details */}
                <div className="rn-portfolio-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="portfolio-details">
                                    <div className="inner">
                                        <h2>Aforo Congreso Fenamix V</h2>
                                        <p className="subtitle">Aplicación móvil para la gestión de aforo del evento Congreso Fenamix V.</p>
                                        <p>Aplicación que permite a los empleados encargados de la seguridad del congreso de Fenamix V controlar los diferentes accesos del público únicamente escáneando el código QR asignado a cada uno. </p>
                                        <p>Proyecto solicitado por la asociación de loterías Fenamix para su salida en el Congreso de Fenamix V (2023) y posteriores.</p>

                                        <div className="portfolio-view-list d-flex flex-wrap">
                                            <div className="port-view">
                                                <span>Framework Frontend</span>
                                                <h4>Flutter (Móvil)</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Framework Backend</span>
                                                <h4>Laravel</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Lenguajes</span>
                                                <h4>Dart & PHP</h4>
                                            </div>
                                        </div>

                                    </div>
                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Details */}

                {/* Start Related Work */}
                <div className="portfolio-related-work pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <span className="theme-color font--18 fontWeight600">Proyectos relacionados</span>
                                    <h2>Otros proyectos</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--10">
                            {/* Start Single Portfolio */}
                            <div className="col-lg-6 col-md-6 col-12 text-center">
                                <div className="related-work text-center mt--30">
                                    <div className="thumb">
                                        <a href="/fenamix-details">
                                            <img src="/assets/images/portfolio/dp-portfolio-03.jpg" alt="Portfolio-images"/>
                                        </a>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <p>Aplicación móvil - Flutter</p>
                                            <h4><a href="/fenamix-details">Información de puestos de lotería alrededor de España</a></h4>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        {/* End Single Portfolio */}
                        </div>
                    </div>
                </div>
                {/* End Related Work */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />  


            </React.Fragment>
        )
    }
}
export default FenamixAforoDetails;
